/**
 * body class bg_color controll
 */
export const BodyBgColorMixin = 
{
    mounted () {
        this.bodyClassAdd();
    },
    destroyed () {
        this.bodyClassRemove();
    },

    methods: {
        bodyClassAdd(){
            var body = document.body;
            body.classList.add("bg_color");
        },

        bodyClassRemove(){
            var body = document.body;
            body.classList.remove("bg_color");
        },
    },
};